<template>
    <div>
        <div class="center">
            <vs-button class="mb-4 float-right" type="flat" @click="editContactUs()">ویرایش</vs-button>
            <div class="p-4 my-4">
                <h5>تماس با ما</h5>
                <div>
                    <strong>آدرس: </strong>
                    <span>{{contact.address}}</span>
                </div>
                <div class="mt-2">
                    <strong>ایمیل: </strong>
                    <span>{{contact.email}}</span>
                </div>
                <div class="mt-2">
                    <strong>تلفن های تماس:</strong> <br/>
                    <vs-row>
                        <vs-col v-for="(item, index) in phone" :key="index" vs-lg="3" vs-sm="4" vs-xs="6">
                            <span>{{item}}</span><br/>
                        </vs-col>
                    </vs-row>
                </div>
            </div>
        </div>

        <div class="text-center my-5">
            <a v-if="contact.linkedin" :href="contact.linkedin" class="p-2">
                <img src="@/assets/images/icon/linkedin.png" class="socialNetworkIcon" />
            </a>
            <a v-if="contact.facebook" :href="contact.facebook" class="p-2">
                <img src="@/assets/images/icon/facebook.png" class="socialNetworkIcon" />
            </a>
            <a v-if="contact.twitter" :href="contact.twitter" class="p-2">
                <img src="@/assets/images/icon/twitter.png" class="socialNetworkIcon" />
            </a>
            <a v-if="contact.instagram" :href="contact.instagram" class="p-2">
                <img src="@/assets/images/icon/instagram.png" class="socialNetworkIcon" />
            </a>
            <a v-if="contact.telegram" :href="contact.telegram">
                <img src="@/assets/images/icon/telegram.png" class="socialNetworkIcon" />
            </a>
        </div>

		<EditContactUs :popupEditContactUs='popupEditContactUs' :ContactUsId='editContactUsId' @updatePopupEditContactUs='updatePopupEditContactUs'/>

    </div>
</template>

<script>
import EditContactUs from './Edit'

export default {
    data() {
        return {
            popupEditContactUs: false,
            editContactUsId: 0,

            contact: {},
            phone: [],
        }
    },

    components: {
		EditContactUs,
    },

    created() {
        this.$vs.loading()
        this.$store.dispatch("getPosts","contact").then((res) => {
            this.editContactUsId = res.data[0].id
            this.contact = JSON.parse(res.data[0].text)
            if(this.contact.phone != null) {
                this.phone = this.contact.phone.split(',')
            }
            this.$vs.loading.close();
        }).catch(() => {
            this.$vs.loading.close()
            this.$vs.notify({
                title: '',
                text: 'خطا در اتصال به اینترنت',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
        })
    },

    methods: {
        editContactUs(){
			this.popupEditContactUs = true
		},
        updatePopupEditContactUs(value, info){
            this.popupEditContactUs = value
            this.contact = JSON.parse(info)
            if(this.contact.phone != null) {
                this.phone = this.contact.phone.split(',')
            }
		},
    }
}
</script>

<style scoped>
.socialNetworkIcon {
    width: calc(var(--vw, 1vw) * 2);
}

.vx-card .vx-card__collapsible-content img {
    display: inline;
}
</style>